"use strict";
angular.module("timeHotSpotsTimeLineModule", ['timeLineItemModule']).
directive("timeHotSpotsTimeLine", ['trsHttpService', '$timeout', function(trsHttpService, $timeout) {
    return {
        replace: true,
        restrict: 'AE',
        scope: {
            timeLineList: '=',
            curSelected: '=',
            limitNum: '@',
            noTitle: '@',
            callback: "&",
        },
        templateUrl: './planningCenter/hotFocus/directive/timeHotSpotsTimeLine/timeHotSpotsTimeLine_tpl.html',
        link: function(scope, $elem, $attrs) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.data = {
                    timeLineContent: {},
                    curSelectedManu: '',
                    allContentLength: ''
                }
                scope.status = {
                    loadFlag: false, // 是否加载更多标志
                }
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}

            /**
             * [description] 监控timeLineList
             * @param  {[type]} nVal  [description]
             * @param  {[type]} oVal) 
             * @return {[type]}       [description]
             */
            scope.$watch('timeLineList', function(nVal, oVal) {
                if (nVal) {
                    if (scope.limitNum || !angular.isUndefined(scope.limitNum)) {
                        scope.data.allContentLength = Object.keys(nVal).length;
                    }
                    scope.data.timeLineContent = nVal;
                    scope.data.curSelectedManu = get_object_first_attribute(scope.timeLineList);
                }
            });

            function get_object_first_attribute(data) {
                for (var key in data) {
                    return data[key][0];
                }
            }

            /**
             * [loadMore 加载更多]
             * @return {[type]} [description]
             */
            scope.loadMore = function() {
                scope.status.loadFlag = true;
                scope.limitNum = scope.data.allContentLength;
            }

            /**
             * [pullUp 收起]
             * @return {[type]} [description]
             */
            scope.pullUp = function() {
                scope.status.loadFlag = false;
                scope.limitNum = 10; // 默认为10
            }

            /**
             * [clickTitle description]点击标题
             * @param  {[type]} obj [description]
             * @return {[type]}     [description]
             */
            scope.clickTitle = function(obj) {
                scope.curSelected = obj;
                scope.data.curSelectedManu = obj;
                $timeout(function() {
                    scope.callback();
                });
            }


        }
    };
}]);